/**
 * Version Composable
 * Provides app version from package.json
 */
import { version } from '../../../package.json'

export function useVersion() {
  return {
    version,
  }
}
